import React from "react";

const IconFilter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 19.961 19.21"
    >
      <g
        id="Group_1525"
        data-name="Group 1525"
        transform="translate(-1465.479 -235.189)"
      >
        <g
          id="Group_1524"
          data-name="Group 1524"
          transform="translate(1466.479 236.189)"
        >
          <line
            id="Line_130"
            data-name="Line 130"
            x1="3.002"
            transform="translate(14.73 2.45)"
            fill="none"
            stroke="#4b4a4a"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            id="Line_131"
            data-name="Line 131"
            x1="9.739"
            transform="translate(0 2.45)"
            fill="none"
            stroke="#4b4a4a"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <path
            id="Path_3799"
            data-name="Path 3799"
            d="M1851.307-456.116q.068,0,.137,0a2.5,2.5,0,0,1,2.5,2.45c0,.015,0,.031,0,.046a2.5,2.5,0,0,1-2.5,2.5,2.5,2.5,0,0,1-2.5-2.5c0-.015,0-.031,0-.046"
            transform="translate(-1839.21 456.12)"
            fill="none"
            stroke="#4b4a4a"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            id="Line_132"
            data-name="Line 132"
            x2="17.731"
            transform="translate(0 14.669)"
            fill="none"
            stroke="#4b4a4a"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <circle
            id="Ellipse_265"
            data-name="Ellipse 265"
            cx="2.496"
            cy="2.496"
            r="2.496"
            transform="translate(9.739 12.219)"
            fill="#fff"
            stroke="#4b4a4a"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            id="Line_133"
            data-name="Line 133"
            x1="17.731"
            transform="translate(0.23 8.758)"
            fill="none"
            stroke="#4b4a4a"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <circle
            id="Ellipse_266"
            data-name="Ellipse 266"
            cx="2.496"
            cy="2.496"
            r="2.496"
            transform="translate(3.231 6.217)"
            fill="#fff"
            stroke="#4b4a4a"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconFilter;
